import { render, staticRenderFns } from "./country-form-page.vue?vue&type=template&id=19928be7&scoped=true&"
import script from "./country-form-page.vue?vue&type=script&lang=js&"
export * from "./country-form-page.vue?vue&type=script&lang=js&"
import style0 from "./country-form-page.vue?vue&type=style&index=0&id=19928be7&lang=scss&scoped=true&"
import style1 from "./country-form-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19928be7",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QForm,QInput,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QForm,QInput,QBtn,QSpinnerIos,QField})
